import axiosHttp from "../../config/axios.interceptor";
import { notificationReducerConstant } from "../reducerConstant";

export const getActiveNotificationCount = () => async (dispatch) => {
  try {
    const notificationData = await axiosHttp.get(`notification`);
    let activeCount = 0;
    let data = notificationData?.data?.data;
    let newData = data?.filter(
      (item) =>
        item.isNew &&
        !item?.is_verified &&
        (item.refer_type === "startotp" || item.refer_type === "endotp")
    );
    data.map((item) => {
      if (item?.isNew) {
        activeCount += 1;
      }
    });
    dispatch({
      type: notificationReducerConstant.GET_ACTIVE_COUNT,
      payload: {
        activeNotificationCount: activeCount,
        notificationData: newData[0] ? newData[0] : {},
      },
    });
  } catch (error) {
    console.log(error);
  }
};
